import dayjs from 'dayjs'
import React from 'react'

import type { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'
import { TimezonedDateString } from '@modules/Timezone/components/TimezonedDateString'

import type { Post } from '../../../types'

export const mapAccessTierNames = (
  access: Post['access'],
  tiers?: Awaited<ReturnType<(typeof MembershipsCreatorV2ApiClient)['getTiers']>>['data']['tiers'],
) => {
  if (!tiers) return

  if (access.type === 'Public') return 'Public (everyone)'

  if (access.type === 'MembersOnly') return 'Members only'

  if (access.type === 'FreeMembers') return 'Free accounts only'

  if (access.type === 'FreeAndPaidMembers') return 'Members & free accounts'

  const selectedTiers = access.tiers?.map(({ id }) => tiers?.find((tier) => tier.id === id))

  return selectedTiers?.map((tier) => tier?.name).join(', ')
}

export const getSubtitle = (
  access: Post['access'],
  tiers?: Awaited<ReturnType<(typeof MembershipsCreatorV2ApiClient)['getTiers']>>['data']['tiers'],
  startsAt?: string,
) => {
  if (!tiers) return

  const accessName = mapAccessTierNames(access, tiers)

  if (startsAt && dayjs(startsAt).isAfter(dayjs())) {
    return (
      <>
        Stream starts{' '}
        <TimezonedDateString date={startsAt} format="MMM D" withTimezoneAbbreviation={false} />
        {' • '}
        {accessName}
      </>
    )
  }

  return accessName
}
